var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "modalPopupLayout",
    class: {
      'active': _vm.visible
    }
  }, [_c('div', {
    staticClass: "documentOption contentWrap"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("문서정보")]), _c('div', {
    staticClass: "overflow content"
  }, [_c('div', {
    staticClass: "option"
  }, [_c('h3', [_vm._v("· 공개정보 설정")]), _c('div', {
    staticClass: "btns"
  }), _c('table', [_vm._m(0), _c('tbody', [_vm._l(_vm.defaultData, function (value, key) {
    return _vm.userData[key] || _vm.activeData[key] ? _c('tr', [_c('td', [_vm._v(_vm._s(value.name))]), _c('td', [_vm._v(_vm._s(!_vm.userData[key] ? _vm.activeData[key] : _vm.userData[key]))])]) : _vm._e();
  }), _vm._l(_vm.userTableData, function (value, key) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(value.name))]), _c('td', [_vm._v(_vm._s(_vm.userData[key]))])]);
  })], 2)])]), _c('div', {
    staticClass: "option"
  }, [_c('h3', [_vm._v("· 공저자 정보 (총 " + _vm._s(_vm.myCoauthors.length) + "명)")]), _c('table', [_vm._m(1), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.userData['loginId']))]), _c('td', [_vm._v(_vm._s(_vm.userData['name']))]), _c('td', [_vm._v("관리자")])]), _vm._l(_vm.myCoauthors, function (coauthor) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(coauthor.loginId))]), _c('td', [_vm._v(_vm._s(coauthor.name))]), _c('td', [_vm._v("공저자권한")])]);
  })], 2)])])]), _c('button', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("닫기")])]), _c('Loading', {
    attrs: {
      "visible": _vm.loading,
      "type": "fixed"
    }
  })], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("항목")]), _c('th', [_vm._v("정보")])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('th', [_vm._v("사용자 ID")]), _c('th', [_vm._v("이름")]), _c('th', [_vm._v("권한")])]);

}]

export { render, staticRenderFns }